import {
  BASED_ON_RECENT_VIEWS_AUTH_ENDPOINT,
  BASED_ON_RECENT_VIEWS_UNAUTH_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';

export function fetchBasedOnRecentViewsAuth({ limit }: { limit: number }) {
  return typedHttp.get(BASED_ON_RECENT_VIEWS_AUTH_ENDPOINT, {
    params: { limit },
    withAuth: true,
    withDeviceId: true,
  });
}

export function fetchBasedOnRecentViewsUnauth({
  productIds,
  limit,
}: {
  productIds: number[];
  limit: number;
}) {
  return typedHttp.get(BASED_ON_RECENT_VIEWS_UNAUTH_ENDPOINT, {
    params: {
      product_ids: productIds.join(','),
      limit,
    },
    withDeviceId: true,
  });
}
